import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import formFieldTypes from '@/forms/constants';
import FormItemDescription from '@/forms/components/FormItemDescription';
import Selectors from '../../hooks/selectors';

const CatalogueCreatedOnListItem = ({ category, code }) => {
  const { createdOn } = Selectors.useDatasetCreatedOn({ category, code });
  return (
    <List.Item className="aridhia-catalogue-created-on-list-item">
      <List.Header>
        <FormattedMessage id="dataset.catalogue.created.on.title" />
      </List.Header>
      <FormItemDescription text={createdOn} field={{ type: formFieldTypes.DATE.type }} />
    </List.Item>
  );
};

export default CatalogueCreatedOnListItem;
